/** `ms → 3:45`. Numeric columns stay mono and right-aligned. */
export function formatDuration(ms: number | null | undefined): string {
  if (ms === null || ms === undefined || !Number.isFinite(ms) || ms < 0) return "—";
  const total = Math.round(ms / 1000);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
}

/** `123.4 → 123.4` and `123.0 → 123`; display label decides whether to append BPM. */
export function formatBpm(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value) || value <= 0) return "—";
  const rounded = Math.round(value * 10) / 10;
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
}

/**
 * Display dates as `dd-mm-yyyy` everywhere in the UI.
 * Accepts `YYYY-MM-DD`, ISO datetimes, and partial MB dates (`YYYY`, `YYYY-MM`).
 */
export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const day = iso.trim().slice(0, 10);
  const full = /^(\d{4})-(\d{2})-(\d{2})$/.exec(day);
  if (full) return `${full[3]}-${full[2]}-${full[1]}`;
  const ym = /^(\d{4})-(\d{2})$/.exec(day);
  if (ym) return `${ym[2]}-${ym[1]}`;
  if (/^\d{4}$/.test(day)) return day;
  return iso;
}

/** `2026-07-29T01:56:00Z → 29-07-2026 01:56`. */
export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const match = /^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2})/.exec(iso);
  if (!match) return formatDate(iso);
  return `${formatDate(match[1])} ${match[2]}`;
}

/** Stored `YYYY-MM-DD` follow-up → `dd-mm-yyyy`. */
export function formatFollowUp(iso: string | null | undefined): string {
  if (!iso) return "";
  const formatted = formatDate(iso);
  return formatted === "—" ? "" : formatted;
}
